export default "__VITE_ASSET__cdac40f5__"